import BaseButton from 'src/Components/Button/BaseButton'

const GemContainer = BaseButton

export default GemContainer
